const sitesetting = {
  getlist: 'sitesetting/getlist',
  add: 'sitesetting/add',
  update: 'sitesetting/update',
  remove: 'sitesetting/remove',
  get: 'sitesetting/get',
  getall: 'sitesetting/getall',
  clearcache: 'sitesetting/clear-cache',
}
export default sitesetting
